__turbopack_context__.v({
  "eyebrow": "ApiAAS-module__T3_2rG__eyebrow",
  "fdesc": "ApiAAS-module__T3_2rG__fdesc",
  "feature": "ApiAAS-module__T3_2rG__feature",
  "ftitle": "ApiAAS-module__T3_2rG__ftitle",
  "grid": "ApiAAS-module__T3_2rG__grid",
  "head": "ApiAAS-module__T3_2rG__head",
  "icon": "ApiAAS-module__T3_2rG__icon",
  "images": "ApiAAS-module__T3_2rG__images",
  "img": "ApiAAS-module__T3_2rG__img",
  "imgRight": "ApiAAS-module__T3_2rG__imgRight",
  "imgWrap": "ApiAAS-module__T3_2rG__imgWrap",
  "imgWrapRight": "ApiAAS-module__T3_2rG__imgWrapRight",
  "list": "ApiAAS-module__T3_2rG__list",
  "section": "ApiAAS-module__T3_2rG__section",
  "subtitle": "ApiAAS-module__T3_2rG__subtitle",
  "title": "ApiAAS-module__T3_2rG__title",
});
